var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5a34e1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.2 3.5999c0-.66274-.5373-1.2-1.2-1.2s-1.2.53726-1.2 1.2v1.2c0 .66274.5373 1.2 1.2 1.2s1.2-.53726 1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.7882 6.90867c.4686-.46863.4686-1.22843 0-1.69706-.4687-.46862-1.2284-.46862-1.6971 0l-.8485.84853c-.4686.46863-.4686 1.22843 0 1.69706s1.2284.46863 1.6971 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6 11.9999c0 .6627-.5373 1.2-1.2 1.2h-1.2c-.6627 0-1.2-.5373-1.2-1.2s.5373-1.2 1.2-1.2h1.2c.6627 0 1.2.5373 1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.06023 7.75722c.46863.46863 1.22843.46863 1.69705 0 .46863-.46863.46863-1.22843 0-1.69706l-.84852-.84852c-.46863-.46863-1.22843-.46863-1.69706 0-.46863.46862-.46863 1.22842 0 1.69705z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 11.9999c0 .6627-.53726 1.2-1.2 1.2h-1.2c-.66274 0-1.2-.5373-1.2-1.2s.53726-1.2 1.2-1.2h1.2c.66274 0 1.2.5373 1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.6 19.1999v-1.2h4.8v1.2c0 1.3255-1.0745 2.4-2.4 2.4s-2.4-1.0745-2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.4011 16.7999c.0175-.4084.248-.7755.5711-1.0306 1.1133-.8791 1.8278-2.2408 1.8278-3.7694 0-2.65096-2.149-4.8-4.8-4.8-2.65096 0-4.8 2.14904-4.8 4.8 0 1.5286.71454 2.8903 1.82783 3.7694.32306.2551.55359.6222.5711 1.0306z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.2733047d7e99d225194b71719b9df272.svg";
export { ForwardRef as ReactComponent };